/* unplugin-vue-components disabled */import { render } from "./dist.vue?vue&type=template&id=23c2905f&scoped=true"
import script from "./dist.vue?vue&type=script&lang=js"
export * from "./dist.vue?vue&type=script&lang=js"

import "./dist.vue?vue&type=style&index=0&id=23c2905f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境微信商家助手yinboshi_weixin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2905f"]])

export default __exports__